export default __webpack_public_path__ + "static/gatsby_github_get_pat4-58ac260daca245a71a8cc84da8a271c5.png";